// CLIENT_ID is an arbitrary id used for connecting websocket/http sessions. This is used to avoid
// notifying the user about updates and double-updating if they were the ones doing the update
export const CLIENT_ID = String(Math.random()).replace('0.', '');
